import { FilterChipProps } from '@shared/components/filter-chip/FilterChip';
import { getLabelFromQueryParam } from 'clerk_common/constants/urls/getLabelFromQueryParam';
import { DropdownQueryParam } from 'clerk_common/constants/urls/queryParams';
import useFilters from './useFilters';

type UseFilterChipsOptions = {
  /** The query param associated with the selected filters. */
  queryParam: DropdownQueryParam;
  /** A list of IDs from the selected options. */
  selectedIds?: string[];
  hideLabel?: boolean;
  tooltipContent?: string;
};

const useFilterChips = (
  allFilters: UseFilterChipsOptions[]
): FilterChipProps[] => {
  const { clearFilters } = useFilters();
  const selectedFilters: FilterChipProps[] = [];

  allFilters.forEach((filter) => {
    if (filter?.selectedIds?.length) {
      selectedFilters.push({
        label: filter.hideLabel
          ? ''
          : getLabelFromQueryParam(filter.queryParam),
        options: filter.selectedIds,
        tooltipContent: filter.tooltipContent,
        onDismiss: async () => {
          const filtersToClear = [];

          if (filter.queryParam === DropdownQueryParam.CREATED_AT_START_DATE) {
            filtersToClear.push(DropdownQueryParam.CREATED_AT_END_DATE);
          }

          if (filter.queryParam === DropdownQueryParam.LAST_ACTIVE_START_DATE) {
            filtersToClear.push(DropdownQueryParam.LAST_ACTIVE_END_DATE);
          }

          if (filter.queryParam === DropdownQueryParam.PICKUP_FIRST_DATE) {
            filtersToClear.push(DropdownQueryParam.PICKUP_SECOND_DATE);
          }

          if (filter.queryParam === DropdownQueryParam.DELIVERY_FIRST_DATE) {
            filtersToClear.push(DropdownQueryParam.DELIVERY_SECOND_DATE);
          }

          clearFilters([filter.queryParam, ...filtersToClear]);
        },
      });
    }
  });

  return selectedFilters;
};

export default useFilterChips;
